import React from 'react'
const InlineError = (props) => (
    <small className="small text-red">{props.errorMessage}</small>
)
export default InlineError